import { MicroMClient, MicromUsersGroups } from "@mcurros2/microm";



export class CustomMicromUsersGroups extends MicromUsersGroups {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);

        this.Title = "Perfiles de Usuario";
        this.HelpText = "* Los perfiles de usuario asignan grupos de permisos";

        this.def.columns.c_user_group_id.prompt = "ID";
        this.def.columns.c_user_group_id.description = "El ID de perfil es generado automáticamente por el sistema";
        this.def.columns.vc_user_group_name.prompt = "Nombre del Perfil";
        this.def.columns.vc_user_group_name.description = "El nombre del perfil de usuario que determinará el nivel de acceso en el sistema.";
        this.def.columns.vc_group_members.prompt = "Miembros del Perfil";
        this.def.columns.vc_group_members.description = "Usuarios asignados a este perfil.";

        // Cambiamos a nombre y apellido para usar en el form de group members
        this.def.lookups.MicromUsers.viewMapping.descriptionIndex = 2;
    }

}